import cn from 'classnames'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { getReplaceParams } from '../../helpers/getReplaceParams'
import { IPartnersCompleteness } from '../../models/IPartnersCompleteness'

import tr from './translations'

import styles from './PartnersCompletenessField.module.scss'

interface IProps {
  partnersCompleteness: IPartnersCompleteness
  onClick: (partnersCompleteness: IPartnersCompleteness) => void
  translationTag: string
  type?: 'actuals' | 'targets' | 'default'
}

export const PartnersCompletenessField = ({
  partnersCompleteness,
  onClick,
  translationTag,
  type = 'default',
}: IProps) => {
  const translationTip = `${tr.partnersCompletenessTip}-${translationTag}`
  const translationText = `${tr.partnersCompleteness}-${translationTag}`
  const replaceParams = getReplaceParams(partnersCompleteness)
  const isActuals = type === 'actuals'
  const isTargets = type === 'targets'

  return (
    <>
      <div className={cn(styles.iconWrap)}>
        <Tooltip
          tipContent={() => (
            <Translation text={translationTip} replaceParams={replaceParams} span />
          )}
        >
          <a onClick={() => onClick(partnersCompleteness)}>
            <div className={styles.fieldContainer}>
              <i className={cn('kbase kbase-warning', styles.icon)} aria-hidden="true" />
              <span
                className={cn({ [styles.actuals]: isActuals }, { [styles.targets]: isTargets })}
              >
                <Translation text={translationText} replaceParams={replaceParams} span />
              </span>
            </div>
          </a>
        </Tooltip>
      </div>
    </>
  )
}
